/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KycEventLogAction {
    SUBMITTED = 'SUBMITTED',
    REVIEWED = 'REVIEWED',
    DELETED = 'DELETED',
    ADDITIONAL_FILE_REQUESTED = 'ADDITIONAL_FILE_REQUESTED',
    ADDITIONAL_FILE_REQUEST_CANCELLED = 'ADDITIONAL_FILE_REQUEST_CANCELLED',
    CERTIFICATION_ATTESTED = 'CERTIFICATION_ATTESTED',
    CERTIFIER_NOMINATED = 'CERTIFIER_NOMINATED',
    CERTIFIED = 'CERTIFIED',
    CERTIFICATION_CANCELLED = 'CERTIFICATION_CANCELLED',
}
